import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthContext from 'contexte/AuthContext'
import PageLoader from 'components/pageLoader/PageLoader'
import Tableau from 'components/DataComponents/Tableau/Tableau'
import Badge from 'components/Badge/Badge'
import { launchError } from 'components/notifications'
import { fetchAllSpDrafts } from 'services/spDraftServices'
import BBookEmpty from 'pages/bBook/components/BBookEmpty'
import { BBookPager } from 'pages/bBook/components/BBookListToolbar'
import { formatParisDate, statusLabel } from './components/spDisplay'

const LIMIT = 10

const SpDrafts = () => {
  const { user } = useContext(AuthContext)
  const navigate = useNavigate()
  const [drafts, setDrafts] = useState([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    fetchAllSpDrafts(user, page, LIMIT)
      .then(setDrafts)
      .catch(() => launchError('Erreur lors du chargement des brouillons'))
      .finally(() => setLoading(false))
  }, [page])

  const tbody = drafts.map(item => ({
    data: [
      item.name || <span className='sp_muted'>Sans nom</span>,
      formatParisDate(item.createdAt),
      formatParisDate(item.collecting_date),
      statusLabel(item.status),
      item.validated_at
        ? <Badge text={`Validé le ${formatParisDate(item.validated_at)}`} color={'#22C55E'} />
        : <Badge text='Brouillon' />,
      <div className='sp_actions'>
        <button className='b_book_row_button' onClick={(e) => { e.stopPropagation(); navigate(`/structured-products/${item._id}/infos`) }}>Modifier</button>
        {!item.validated_at && (
          <button className='b_book_row_button' onClick={(e) => { e.stopPropagation(); navigate(`/structured-products/${item._id}/recap`) }}>Valider</button>
        )}
      </div>,
    ],
  }))

  return (
    <>
      <div className='b_book_title_component'>
        <h1 className='b_book_page_title'>Brouillons</h1>
        <button className='b_book_action_button' onClick={() => navigate('/structured-products/new')}>Nouveau produit</button>
      </div>
      <p className='b_book_hint b_book_page_lede'>
        Un brouillon n'est visible dans l'app que par l'utilisateur de preview. La validation (onglet Récap du brouillon) le publie, crée le produit dans neo4j et programme son lancement.
      </p>

      <div className='b_book_card'>
        {loading ? (
          <div className='pageLoaderBox'><PageLoader /></div>
        ) : tbody.length ? (
          <div className='table-container'>
            <Tableau thead={['Nom', 'Créé le', 'Collecte', 'Statut prévu', 'État', '']} tbody={tbody} />
            <BBookPager page={page} hasNext={drafts.length === LIMIT} onChange={setPage} />
          </div>
        ) : (
          <BBookEmpty title='Aucun brouillon' hint='Créez un produit avec « Nouveau produit » : il reste en brouillon tant qu’il n’est pas validé.' />
        )}
      </div>
    </>
  )
}

export default SpDrafts
